import { motion } from "framer-motion";
import { FileSpreadsheet, Receipt, CheckCircle2 } from "lucide-react";

const features = [
  {
    icon: FileSpreadsheet,
    title: "Bank statements to ledgers",
    description:
      "Upload XLS/CSV statements. Genie auto-classifies 250+ lines in minutes with balanced vouchers ready for approval.",
  },
  {
    icon: Receipt,
    title: "Purchase invoices to entries",
    description:
      "Stock and services invoices parsed, taxes applied, ledgers mapped, then queued for review. Best part it learns from your Tally & guidance!",
  },
  {
    icon: CheckCircle2,
    title: "Batch approve, then post to Tally",
    description:
      "Seniors review previews, approve batches in one click, and Genie posts into Tally using native import formats; no copy‑paste, no re‑typing.",
  },
];

const WhatGenieDoes = () => {
  return (
    <section className="section-padding bg-section">
      <div className="container-narrow mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground mb-4">
            From documents to approved Tally vouchers
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-card rounded-2xl p-8 card-elevated border border-border"
            >
              <div className="w-14 h-14 rounded-xl bg-genie-soft flex items-center justify-center mb-6">
                <feature.icon className="w-7 h-7 text-primary" />
              </div>
              <h3 className="font-display text-xl font-semibold text-foreground mb-3">
                {feature.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatGenieDoes;
